import $ from 'jquery';
import FJBase from './FJBase';
import FJDomUtil from '../../../util/FJDomUtil';

class FJGlitch extends FJBase {
    constructor(props) {
        super(props);

        props = props || {};
        this._name = 'FJGlitch';
        this._offset = typeof props.offset != 'undefined' ? props.offset : 10; // 阴影偏移距离，比例值
        this._angle = typeof props.angle != 'undefined' ? props.angle : 0; // 阴影偏移角度
        this._color1 = (props && props.color1) || '#f00000'; // 阴影颜色
        this._color2 = (props && props.color2) || '#f00000'; // 阴影颜色
        this._textColor = (props && props.textColor) || ''; // 文字颜色
        this._position = (props && props.position) || 'absolute';
    }

    encode() {
        return {
            name: this._name,
            offset: this._offset,
            angle: this._angle,
            color: this._color,
            textColor: this._textColor,
        };
    }
    decode(data) {
        this._offset = data.offset;
        this._angle = data.angle;
        this._color = data.color;
        this._textColor = data.textColor;
    }
    clone() {
        let object = new FJGlitch();
        object.decode(this);

        return object;
    }
    get name() {
        return this._name;
    }

    set color(color) {
        this._color = color;
    }
    get color() {
        return this._color;
    }

    /**
     * 更新文字某一行文字样式
     * @param styleData
     * @param lineIdx
     */
    updateStyle(styleData, lineIdx) {
        if (!this._layer) return;

        let lineLayer = $(this._layer).find('div');
        if (lineIdx < lineLayer.length) {
            let ele = lineLayer[lineIdx];
            if (this._textColor) {
                $(ele).css({
                    ...styleData,
                    color: this._textColor,
                });
            } else {
                $(ele).css(styleData);
            }
        }

        let fontSize = parseFloat(styleData.fontSize) * (styleData.contentScale ? styleData.contentScale : 1);
        let ref = (0.2 * fontSize * this.offset) / 100;
        let deg = (this.angle / 180) * Math.PI;
        let x = ref * Math.cos(deg);
        let y = ref * Math.sin(deg);

        const textShadowList = [
            x + 'px ' + y + 'px 0px ' + this._color2,
            -1 * x + 'px ' + -1 * y + 'px 0px ' + this._color1,
        ];
        $(this._layer).css({
            textShadow: textShadowList.join(','),
        });
    }

    /**
     * @desc 更新所有行文字文字样式
     * @param styleData
     */
    updateAllLineStyle(styleData) {
        if (!this._layer) return;

        let lineLayer = $(this._layer).find('div');
        for (let i = 0; i < lineLayer.length; i++) {
            let ele = lineLayer[i];
            if (this._textColor) {
                $(ele).css({
                    ...styleData,
                    color: this._textColor,
                });
                FJDomUtil.updateSpanTextNodeColor(ele, this._textColor);
            } else {
                $(ele).css(styleData);
            }
        }

        let fontSize = parseFloat(styleData.fontSize) * (styleData.contentScale ? styleData.contentScale : 1);
        let ref = (0.2 * fontSize * this.offset) / 100;
        let deg = (this.angle / 180) * Math.PI;
        let x = ref * Math.cos(deg);
        let y = ref * Math.sin(deg);

        const textShadowList = [
            x + 'px ' + y + 'px 0px ' + this._color2,
            -1 * x + 'px ' + -1 * y + 'px 0px ' + this._color1,
        ];

        $(this._layer).css({
            textShadow: textShadowList.join(','),
        });
    }

    isEqual(style) {
        let ret = true;

        ret &= this._offset === style.offset;
        ret &= this._angle === style.angle;
        ret &= this._color === style.color;

        return ret;
    }

    clear() {
        if (this._layer && this._layer.parentNode) {
            this._layer.parentNode.removeChild(this._layer);
        }
    }
}

export default FJGlitch;
